import { render, staticRenderFns } from "./add-video.vue?vue&type=template&id=4a458f32"
import script from "./add-video.vue?vue&type=script&lang=js"
export * from "./add-video.vue?vue&type=script&lang=js"
import style0 from "./add-video.vue?vue&type=style&index=0&id=4a458f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports